import { initSubstationCrud, SubstationCrud } from "./substation.model";
import { F33Crud, initF33Crud, initF33SsCrud } from "./feeder33.model";
import { getInitRegion, Region } from "./region.model";
import { TransmissionStation } from "./transmission.station.model";

export interface Feeder11 {
    id: number;
    name: string;
    number: string;
    substation?: string;
    transmissionStation?: string;
}

export interface F11Crud {
    id: number;
    name: string;
    number: string;
    transmissionStation?: TransmissionStation;
    transmissionStationId?: number;
    substation?: SubstationCrud;
    substationId?: number;
    feeder33?: F33Crud;
    feeder33Id?: number;
    region: Region;
    nameplateRating: string;
    utilityId: number;
    guid: string;
    code: string;
    feederBand: string;
}

export interface FeederOption {
    id: number;
    name: string;
    number: string;
    type: number;
}

export interface F11CrudCreate {
    id: number;
    name: string;
    number: string;
    transmissionStationId?: number;
    substationId?: number;
    feeder33Id?: number;
    nameplateRating: string;
    regionId: number;
    utilityId: number;
}

export function initF11Crud(): F11Crud {
    return {
        id: 0,
        name: '',
        number: '',
        transmissionStation: new TransmissionStation(),
        transmissionStationId: undefined,
        substation: initSubstationCrud(),
        substationId: undefined,
        feeder33: initF33Crud(),
        feeder33Id: undefined,
        region: getInitRegion(),
        nameplateRating: '',
        utilityId: 0,
        guid: '',
        code: '',
        feederBand: ''
    };
}

export function mapObjToCreateObj(f11: F11Crud): F11CrudCreate {
    return {
        id: f11.id,
        name: f11.name,
        number: f11.number,
        transmissionStationId: f11.transmissionStation?.id,
        substationId: f11.substationId,
        feeder33Id: f11.feeder33Id,
        nameplateRating: f11.nameplateRating,
        regionId: f11.region.id,
        utilityId: f11.utilityId
    };
}